import {
    getJson,
    putJson,
    postJson,
    deleteJson,
} from './ServiceHelperMethods';

class AdminService {
    static async me() {
        return getJson('admin/me');
    }

    static async listSchemas() {
        return getJson('admin/schemas');
    }

    static async listEntries(schema, { limit = 50, skip = 0, q = '', includeDeleted = false } = {}) {
        const params = new URLSearchParams();
        params.set('limit', limit);
        params.set('skip', skip);
        if (q) params.set('q', q);
        if (includeDeleted) params.set('includeDeleted', 'true');
        return getJson(`admin/schemas/${schema}?${params.toString()}`);
    }

    static async getEntry(schema, id) {
        return getJson(`admin/schemas/${schema}/${encodeURIComponent(id)}`);
    }

    static async updateEntry(schema, id, body) {
        return putJson(`admin/schemas/${schema}/${encodeURIComponent(id)}`, body);
    }

    static async deleteEntry(schema, id, { hard = false } = {}) {
        const suffix = hard ? '?hard=true' : '';
        return deleteJson(`admin/schemas/${schema}/${encodeURIComponent(id)}${suffix}`);
    }

    static async deactivateUser(userId, reason) {
        return postJson(`admin/users/${encodeURIComponent(userId)}/deactivate`, { reason });
    }

    static async listAdminWorkspaces({ limit = 50, skip = 0 } = {}) {
        const params = new URLSearchParams({ limit, skip });
        return getJson(`admin/workspaces?${params.toString()}`);
    }

    static async transferWorkspace(workspaceId, newOwnerId) {
        return postJson(`admin/workspaces/${encodeURIComponent(workspaceId)}/transfer`, {
            newOwnerId,
        });
    }

    static async deleteWorkspace(workspaceId) {
        return deleteJson(`admin/workspaces/${encodeURIComponent(workspaceId)}`);
    }

    static async getAuditLog({ limit = 50, skip = 0, ...filters } = {}) {
        const params = new URLSearchParams();
        params.set('limit', limit);
        params.set('skip', skip);
        for (const [k, v] of Object.entries(filters)) {
            if (v != null && v !== '') params.set(k, v);
        }
        return getJson(`admin/audit-log?${params.toString()}`);
    }

    static async listLegacyModels() {
        return getJson('admin/models/legacy');
    }

    static async pruneLegacyModels() {
        return postJson('admin/models/prune-legacy', {});
    }
}

export default AdminService;
